const KEY = "fathom_uid";

export function getUserId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `u-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function setUserId(id) {
  localStorage.setItem(KEY, id);
}

export function resetAnon() {
  localStorage.removeItem(KEY);
  return getUserId();
}
